export default __webpack_public_path__ + "static/media/agentTemplate.e0f9cd2e.svg";